// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"sx_a bhs_a bhs_r bhs_j","Photos__img":"sx_b bhs_b"};